import * as React from 'react'
import { SectionWrapper } from '../../components/SectionWrapper'
import styles from './TestSection.module.scss'

export const renderTestSection = () => <TestSection />

const TestSection = () => {
  return (
    <SectionWrapper contentClassName={styles.baseContent}>
      <div className={styles.content}>This is a test bespoke component</div>
    </SectionWrapper>
  )
}

export default TestSection
